export default __webpack_public_path__ + "static/media/Whiteboard with plants.15797888.svg";